<template>
  <table class="paymentsList">
    <thead>
      <tr>
        <th></th>
        <th v-for="column in columns" :key="column.title" class="paymentsList__cellDataHeading">
          {{ column.title }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="payment in data" :key="payment.id">
        <td class="paymentsList__cellIndicator">
          <div class="paymentsList__indicator" :class="getPaymentIndicatorClass(payment)"></div>
        </td>
        <td v-for="column in columns" :key="column.title" class="paymentsList__cellData">
          <div class="paymentsList__dataWrapper">
            {{ payment[column.dataKey] }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getPaymentIndicatorClass(payment) {
      if (payment.status === 'SUCCESS') return '-success';
      if (payment.status === 'FAIL') return '-fail';
      return null;
    },
  },
};
</script>

<style>
.paymentsList tr {
  @apply h-full;
}

.paymentsList td {
  @apply p-0;
}

.paymentsList tbody > tr:not(:first-child) > td {
  @apply pt-2;
}

.paymentsList__cellDataHeading {
  @apply px-4 py-2 text-secondary;
}

.paymentsList__cellIndicator {
  @apply h-full w-[5px];
}

.paymentsList__indicator {
  @apply w-[5px] h-full rounded-l-md bg-gray border border-gray border-solid border-r-0;
}

.paymentsList__indicator.-success {
  @apply bg-primary border-primary;
}

.paymentsList__indicator.-fail {
  @apply bg-warning border-warning;
}

.paymentsList__cellData {
  @apply h-full p-0;
}

.paymentsList__cellData:last-child .paymentsList__dataWrapper {
  @apply border-r rounded-r-md;
}

.paymentsList__dataWrapper {
  @apply flex h-full items-center p-4 border-0 border-t border-b border-gray border-solid;
}

@supports not (-moz-appearance: none) {
  .paymentsList {
    @apply h-[1px];
  }
}
</style>
